const dateTimeFormatter = new Intl.DateTimeFormat("th-TH", {
  dateStyle: "medium",
  timeStyle: "short",
  timeZone: "Asia/Bangkok",
});

const dateFormatter = new Intl.DateTimeFormat("th-TH", {
  dateStyle: "medium",
  timeZone: "Asia/Bangkok",
});

const numberFormatter = new Intl.NumberFormat("th-TH");
const bahtFormatter = new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB" });

export function formatDateTime(value: unknown) {
  if (typeof value !== "string" || !value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : dateTimeFormatter.format(date);
}

export function formatDate(value: unknown) {
  if (typeof value !== "string" || !value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : dateFormatter.format(date);
}

export function formatNumber(value: unknown) {
  return typeof value === "number" ? numberFormatter.format(value) : "0";
}

export function formatBahtMinor(value: unknown) {
  return typeof value === "number" ? bahtFormatter.format(value / 100) : "—";
}

export function shortId(value: unknown) {
  if (typeof value !== "string") return "—";
  return value.length > 12 ? `${value.slice(0, 8)}…${value.slice(-4)}` : value;
}

export function humanize(value: unknown) {
  if (typeof value !== "string" || !value) return "—";
  return value.replaceAll("_", " ").toLocaleLowerCase().replace(/(^|\s)\S/g, (letter) => letter.toLocaleUpperCase());
}

export function errorMessage(error: unknown) {
  const code = error instanceof Error ? error.message : "unknown_error";
  const messages: Record<string, string> = {
    stripe_payment_not_configured: "ยังไม่ได้ตั้งค่า Stripe Secret Key ที่เซิร์ฟเวอร์",
    stripe_payment_retry_required: "Stripe ยังตอบกลับไม่สำเร็จ กรุณาลองอีกครั้งด้วยรายการเดิม",
    stripe_payment_api_failed: "Stripe ไม่สามารถสร้างหรืออ่าน Checkout ได้ กรุณาตรวจการตั้งค่าบัญชี",
    invalid_payment_amount: "กรุณากรอกยอดตั้งแต่ 10 ถึง 999,999.99 บาท และทศนิยมไม่เกิน 2 ตำแหน่ง",
    invalid_payment_title: "กรุณากรอกชื่อสินค้าหรือบริการไม่เกิน 120 ตัวอักษร",
    invalid_payment_description: "กรุณากรอกรายละเอียดไม่เกิน 1,000 ตัวอักษร",
    payment_idempotency_conflict: "รายการนี้ส่งไปแล้วด้วยข้อมูลเดิม กรุณาลองใหม่หรือสร้างรายการใหม่",
    stale_user_profile: "ข้อมูลผู้ใช้ถูกแก้ไขแล้ว กรุณาปิดหน้าต่าง กดโหลดใหม่ แล้วลองอีกครั้ง",
    user_profile_not_found: "ไม่พบโปรไฟล์ผู้ใช้ กรุณาโหลดรายการใหม่",
    invalid_full_name: "กรุณากรอกชื่อผู้ใช้ไม่เกิน 120 ตัวอักษร",
    invalid_locale: "ภาษาที่เลือกไม่ถูกต้อง",
    invalid_reason: "กรุณากรอกเหตุผล 3–500 ตัวอักษร",
    cannot_suspend_self: "ไม่สามารถระงับบัญชีที่กำลังใช้งานอยู่",
    use_admin_access_management: "กรุณาจัดการบัญชีผู้ดูแลผ่านหน้า Admin access",
    authentication_required: "กรุณาเข้าสู่ระบบอีกครั้ง",
    admin_access_denied: "บัญชีนี้ไม่มีสิทธิ์เข้า Admin Console",
    admin_permission_required: "คุณไม่มีสิทธิ์ทำรายการนี้",
    super_admin_required: "เฉพาะ Super Admin เท่านั้น",
    stale_admin_version: "ข้อมูลสิทธิ์ถูกแก้ไขแล้ว กรุณาโหลดใหม่",
    last_super_admin_required: "ระบบต้องมี Super Admin ที่ใช้งานได้อย่างน้อย 1 คน",
    origin_not_allowed: "โดเมนนี้ไม่ได้รับอนุญาตให้เรียก Admin API",
    invalid_credentials: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
    Invalid_login_credentials: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
  };
  return messages[code] || code.replaceAll("_", " ");
}
